
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("2enys"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("2enys", function(module, exports) {

let $19ff290e7235cd0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19ff290e7235cd0a$var$load("cRtGo"),
    $19ff290e7235cd0a$var$load("s4822"),
    $19ff290e7235cd0a$var$load("3q2Ng"),
    $19ff290e7235cd0a$var$load("jRpDi"),
    $19ff290e7235cd0a$var$load("iXxzp"),
    $19ff290e7235cd0a$var$load("dYtBN"),
    $19ff290e7235cd0a$var$load("kNV5Y"),
    $19ff290e7235cd0a$var$load("jUBhK"),
    $19ff290e7235cd0a$var$load("ddJJa"),
    $19ff290e7235cd0a$var$load("27glK"),
    $19ff290e7235cd0a$var$load("bvY53"),
    $19ff290e7235cd0a$var$load("f6ci5"),
    $19ff290e7235cd0a$var$load("7jSfd"),
    $19ff290e7235cd0a$var$load("4HZlX"),
    $19ff290e7235cd0a$var$load("kDqHr"),
    $19ff290e7235cd0a$var$load("gT8XU"),
    $19ff290e7235cd0a$var$load("3GuOt"),
    $19ff290e7235cd0a$var$load("3Mspc"),
    $19ff290e7235cd0a$var$load("9aQIt"),
    $19ff290e7235cd0a$var$load("XZauT"),
    $19ff290e7235cd0a$var$load("4S1SF"),
    $19ff290e7235cd0a$var$load("lm9Lt"),
    $19ff290e7235cd0a$var$load("9wPDc"),
    $19ff290e7235cd0a$var$load("1MWOL"),
    $19ff290e7235cd0a$var$load("6fQco"),
    $19ff290e7235cd0a$var$load("aOY32"),
    $19ff290e7235cd0a$var$load("3MYQs"),
    $19ff290e7235cd0a$var$load("6SWFK"),
    $19ff290e7235cd0a$var$load("5zapo"),
    $19ff290e7235cd0a$var$load("jiFtb"),
    $19ff290e7235cd0a$var$load("6wr18"),
    $19ff290e7235cd0a$var$load("9atVd"),
    $19ff290e7235cd0a$var$load("dek7I"),
    $19ff290e7235cd0a$var$load("6iz6l"),
    $19ff290e7235cd0a$var$load("4SCW2"),
    $19ff290e7235cd0a$var$load("ffEVr"),
    $19ff290e7235cd0a$var$load("hhss7"),
    $19ff290e7235cd0a$var$load("gepVN"),
    $19ff290e7235cd0a$var$load("Wowvf"),
    $19ff290e7235cd0a$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("gBJCd"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("gBJCd", function(module, exports) {

let $c1737c524cc7679b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c1737c524cc7679b$var$load("cRtGo"),
    $c1737c524cc7679b$var$load("s4822"),
    $c1737c524cc7679b$var$load("6wr18"),
    $c1737c524cc7679b$var$load("2tIxk"),
    $c1737c524cc7679b$var$load("dLq4a"),
    $c1737c524cc7679b$var$load("27glK"),
    $c1737c524cc7679b$var$load("bvY53"),
    $c1737c524cc7679b$var$load("ffEVr"),
    $c1737c524cc7679b$var$load("219St"),
    $c1737c524cc7679b$var$load("b1DMS"),
    $c1737c524cc7679b$var$load("gepVN"),
    $c1737c524cc7679b$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("1MZAO"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("1MZAO", function(module, exports) {

let $14da0d29c8079b1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14da0d29c8079b1e$var$load("buoeZ"),
    $14da0d29c8079b1e$var$load("h3ABO"),
    $14da0d29c8079b1e$var$load("5o4Kn"),
    $14da0d29c8079b1e$var$load("6rS39"),
    $14da0d29c8079b1e$var$load("kbwlB"),
    $14da0d29c8079b1e$var$load("2OkLl"),
    $14da0d29c8079b1e$var$load("2YffH"),
    $14da0d29c8079b1e$var$load("1Urow"),
    $14da0d29c8079b1e$var$load("4vx41"),
    $14da0d29c8079b1e$var$load("9XOeB"),
    $14da0d29c8079b1e$var$load("xu7ej"),
    $14da0d29c8079b1e$var$load("iQ4FP"),
    $14da0d29c8079b1e$var$load("71gca"),
    $14da0d29c8079b1e$var$load("hqUaT"),
    $14da0d29c8079b1e$var$load("k3Yy8"),
    $14da0d29c8079b1e$var$load("bUxH9"),
    $14da0d29c8079b1e$var$load("im1VN"),
    $14da0d29c8079b1e$var$load("lG1w2"),
    $14da0d29c8079b1e$var$load("9anPW"),
    $14da0d29c8079b1e$var$load("gWJnq"),
    $14da0d29c8079b1e$var$load("i6XKW"),
    $14da0d29c8079b1e$var$load("1BN67"),
    $14da0d29c8079b1e$var$load("aapZc"),
    $14da0d29c8079b1e$var$load("gnDXu"),
    $14da0d29c8079b1e$var$load("iqTGf"),
    $14da0d29c8079b1e$var$load("3q2Ng"),
    $14da0d29c8079b1e$var$load("jRpDi"),
    $14da0d29c8079b1e$var$load("jUBhK"),
    $14da0d29c8079b1e$var$load("ddJJa"),
    $14da0d29c8079b1e$var$load("f6ci5"),
    $14da0d29c8079b1e$var$load("lTK3c"),
    $14da0d29c8079b1e$var$load("1WXdc"),
    $14da0d29c8079b1e$var$load("cFYW8"),
    $14da0d29c8079b1e$var$load("lssZe"),
    $14da0d29c8079b1e$var$load("b2FtX"),
    $14da0d29c8079b1e$var$load("lM64y"),
    $14da0d29c8079b1e$var$load("gfskt"),
    $14da0d29c8079b1e$var$load("6iz6l"),
    $14da0d29c8079b1e$var$load("4SCW2"),
    $14da0d29c8079b1e$var$load("c0JsV"),
    $14da0d29c8079b1e$var$load("1OKix"),
    $14da0d29c8079b1e$var$load("lVrrs"),
    $14da0d29c8079b1e$var$load("3NkiL"),
    $14da0d29c8079b1e$var$load("cRtGo"),
    $14da0d29c8079b1e$var$load("6wr18"),
    $14da0d29c8079b1e$var$load("jvHRs"),
    $14da0d29c8079b1e$var$load("2tIxk"),
    $14da0d29c8079b1e$var$load("dLq4a"),
    $14da0d29c8079b1e$var$load("27glK"),
    $14da0d29c8079b1e$var$load("bvY53"),
    $14da0d29c8079b1e$var$load("DhQ4t"),
    $14da0d29c8079b1e$var$load("hhss7"),
    $14da0d29c8079b1e$var$load("Wowvf"),
    $14da0d29c8079b1e$var$load("ffEVr"),
    $14da0d29c8079b1e$var$load("219St"),
    $14da0d29c8079b1e$var$load("b1DMS"),
    $14da0d29c8079b1e$var$load("jnVKv"),
    $14da0d29c8079b1e$var$load("s4822"),
    $14da0d29c8079b1e$var$load("7EorR"),
    $14da0d29c8079b1e$var$load("bgHzk"),
    $14da0d29c8079b1e$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.dba16c85.js.map
